var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 10,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m11.014 4.765-3.64-1.178-1.48-3.31L4.611 3.72.986 4.96l3.77 1.286 1.35 3.203 1.412-3.335 3.496-1.348Z",
  fill: "#fff"
})));
export { SvgStar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMiAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIKICAgIGQ9Ik0xMS4wMTM5IDQuNzY1MDZMNy4zNzMxMyAzLjU4NzA2TDUuODkzMzYgMC4yNzcxMzFMNC42MTE1NCAzLjcxOTJMMC45ODYwODkgNC45NTk5Mkw0Ljc1NjA0IDYuMjQ0NzhMNi4xMDY2MyA5LjQ0Nzg2TDcuNTE3NjIgNi4xMTI2M0wxMS4wMTM5IDQuNzY1MDZaIgogICAgZmlsbD0iI2ZmZmZmZiIgLz4KPC9zdmc+";